import React from "react";

const AboutCollabration = () => {
    return (
        <>
            <div className='about-area pd-top-120'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='section-title mt-5 mt-lg-0 d-flex flex-column align-items-center gap-1'>
                                <h6 className='sub-title'>OUR COLLABRATION</h6>
                                <h2 className='title'>
                                    Our Strategic Partnership <span>SIG Casting</span>
                                </h2>
                                <img
                                    className='main-img rounded mt-5'
                                    src='assets/img/about/collab.jfif'
                                    alt='img'
                                    width={680}
                                />
                                <p className='content mt-5'>
                                    We are excited to announce our strategic partnership with SIG Casting, a leader in the casting industry renowned for its advanced manufacturing capabilities and high-quality products. This collaboration allows us to combine our expertise with SIG Casting’s cutting-edge casting technologies to deliver innovative, high-performance solutions to our customers. Collaboration Overview: Through this partnership, we leverage SIG Casting’s extensive experience in precision manufacturing, ensuring high-quality, durable products tailored to meet our clients' needs. Together, we aim to improve production efficiency, reduce costs, and accelerate time-to-market. Key Contributions: SIG Casting brings advanced casting processes like sand casting, die casting, and investment casting, ensuring top-notch product quality. Our Role is to handle product design, customer engagement, and distribution, integrating SIG Casting’s solutions into our product offerings. This partnership strengthens our ability to deliver superior casting solutions across industries, including automotive, aerospace, and industrial manufacturing, while continuing to drive innovation and excellence in the field.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AboutCollabration;
